import {UserManager} from 'oidc-client';
import {config} from './config';

export const userManager = new UserManager(config);